var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowloadFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_7960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7481 0.449357L30.7484 0.449721L42.5716 12.8524C42.7369 13.0386 42.8416 13.2702 42.8416 13.4945V41.6104C42.8416 44.927 40.1021 47.6563 36.7844 47.6563H11.37C8.05229 47.6563 5.31274 44.927 5.31274 41.6104V6.20179C5.31274 2.88562 8.05228 0.15625 11.37 0.15625H30.0948C30.3332 0.15625 30.571 0.262892 30.7481 0.449357ZM31.4466 3.8266L31.0156 3.37413V3.99903V9.55263C31.0156 11.2225 32.3696 12.562 34.0367 12.562H39.1845H39.7679L39.3655 12.1396L31.4466 3.8266ZM29.1967 2.2251V1.9751H28.9467H11.37C9.05272 1.9751 7.1316 3.89527 7.1316 6.20179V41.6104C7.1316 43.93 9.06538 45.8375 11.37 45.8375H36.7844C39.1012 45.8375 41.0228 43.9295 41.0228 41.6104V14.6309V14.3809H40.7728H34.0367C31.3567 14.3809 29.1967 12.2311 29.1967 9.55263V2.2251Z",
    fill: "#131313",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5349 37.8376H33.6189C34.1318 37.8376 34.5401 38.2488 34.5401 38.747C34.5401 39.2465 34.1302 39.6564 33.6307 39.6564H14.5349C14.0354 39.6564 13.6255 39.2465 13.6255 38.747C13.6255 38.2472 14.0354 37.8376 14.5349 37.8376Z",
    fill: "#131313",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1676 19.9756V19.3397L22.7345 19.8053L17.9595 24.9399C17.9592 24.9402 17.9589 24.9405 17.9586 24.9408C17.6115 25.3052 17.0375 25.3334 16.6517 24.9855C16.2889 24.6486 16.2643 24.0673 16.6063 23.7074L16.608 23.7056L23.4014 16.4138C23.5774 16.2288 23.8143 16.1215 24.0657 16.1215C24.3166 16.1215 24.5535 16.2287 24.73 16.4138C24.7303 16.4141 24.7306 16.4144 24.7308 16.4147L31.5234 23.7056L31.5234 23.7056L31.5251 23.7074C31.8661 24.0663 31.8445 24.6387 31.4759 24.9886C31.3049 25.1508 31.0776 25.233 30.8596 25.233C30.6176 25.233 30.3811 25.135 30.1953 24.9407L25.4195 19.8053L24.9864 19.3397V19.9756V32.6366C24.9864 33.1362 24.5768 33.546 24.077 33.546C23.5775 33.546 23.1676 33.1361 23.1676 32.6366V19.9756Z",
    fill: "#131313",
    stroke: "white",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_7960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowloadFileIcon);
export default __webpack_public_path__ + "static/media/dowload_file_icon.a313b9ebeec21f755f906b45252b9254.svg";
export { ForwardRef as ReactComponent };